import { render } from "./FeedbackForm.vue?vue&type=template&id=40eb848a"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"

import "./FeedbackForm.vue?vue&type=style&index=0&id=40eb848a&lang=scss"
script.render = render

export default script